import React from 'react';
import SMBSliderBoxes from './smb-slider-boxes';
import '../css/smb-slider.less';

const SMBSlider = () => {
    const boxes = [
        {
            caption: 'Contact us',
            url: null,
            imgSrc: '/wcsstore/hpusstore/images/Contact_latest-compressor.png',
            openStyle: null,
            isModal: true,
            modalContent: '<h2>Contact US SMB sales 866-625-6133</h2><p>(8am-12am EST Monday-Friday and 10am-12am EST Saturday-Sunday.)</p><h2>Contact US Consumer sales 866-625-6980</h2><p>(8 AM - 2 AM EST Monday-Sunday)</p>',
        },
        {
            caption: 'Email us',
            url: `${process.env.BASENAME}/SendEmailView?catalogId=10051&langId=-1&storeId=10151`,
            imgSrc: '/wcsstore/hpusstore/images/email-compressor.png',
            openStyle: 'width=1290,height=600',
            isModal: false,
        }
    ];
    return(
        <div id="custom-slider">
            {boxes.map((box, i) => {
                return <SMBSliderBoxes key={i} data={box} />;
            })}
        </div>
    );
}
 
export default SMBSlider;

